(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;

  /* ---------- Reveals (un solo observer) ---------- */
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, [data-mt-observar]');
    if (!('IntersectionObserver' in window) || sinMovimiento) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      observer.observe(el);
    });
  }

  /* ---------- Héroe spotlight: el foco sigue al cursor ---------- */
  function initFoco(root) {
    (root || document).querySelectorAll('[data-mt-foco]').forEach(function (hero) {
      if (hero.dataset.mtInit || tactil || sinMovimiento) return;
      hero.dataset.mtInit = '1';
      var foco = hero.querySelector('.mt-hero-foco');
      if (!foco) return;
      var raf = null;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width) * 100;
        var y = ((ev.clientY - r.top) / r.height) * 100;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          foco.style.setProperty('--fx', x + '%');
          foco.style.setProperty('--fy', y + '%');
        });
      });
      hero.addEventListener('pointerleave', function () {
        foco.style.removeProperty('--fx');
        foco.style.removeProperty('--fy');
      });
    });
  }

  /* ---------- CTA magnético ---------- */
  function initMagnetico(root) {
    if (tactil || sinMovimiento) return;
    (root || document).querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      var fuerza = parseFloat(btn.dataset.mtMagnetico) || 6;
      btn.addEventListener('pointermove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = (ev.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (ev.clientY - (r.top + r.height / 2)) / (r.height / 2);
        btn.style.setProperty('--mx', (dx * fuerza).toFixed(1) + 'px');
        btn.style.setProperty('--my', (dy * fuerza * 0.6).toFixed(1) + 'px');
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  /* ---------- Selector de escenario ---------- */
  function initEscenarios(root) {
    (root || document).querySelectorAll('[data-mt-escenarios]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var tabs = sec.querySelectorAll('.mt-esc-tab');
      var fotos = sec.querySelectorAll('.mt-esc-fotos > img');
      var textos = sec.querySelectorAll('.mt-esc-texto');
      var auto = parseInt(sec.dataset.mtAuto, 10) || 0;
      var actual = 0;
      var timer = null;
      function mostrar(i) {
        actual = i;
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        fotos.forEach(function (f, k) { f.classList.toggle('mt-activa', k === i); });
        textos.forEach(function (t, k) { t.classList.toggle('mt-activa', k === i); t.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        sec.querySelectorAll('[data-mt-escena-capa]').forEach(function (c) { c.classList.toggle('mt-activa', parseInt(c.dataset.mtEscenaCapa, 10) === i); });
      }
      function programar() {
        if (!auto || sinMovimiento) return;
        clearInterval(timer);
        timer = setInterval(function () { mostrar((actual + 1) % tabs.length); }, auto * 1000);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { mostrar(k); clearInterval(timer); timer = null; });
        t.addEventListener('keydown', function (ev) {
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowLeft') {
            var n = (k + (ev.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            tabs[n].focus(); mostrar(n); clearInterval(timer);
          }
        });
      });
      sec.addEventListener('mouseenter', function () { clearInterval(timer); });
      mostrar(0);
      programar();
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs-punto');
      var items = sec.querySelectorAll('.mt-hs-item');
      function activar(i) {
        puntos.forEach(function (p, k) { p.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('mt-activa', k === i); });
      }
      puntos.forEach(function (p, k) {
        p.addEventListener('click', function () { activar(k); });
        p.addEventListener('mouseenter', function () { activar(k); });
      });
      items.forEach(function (it, k) {
        it.addEventListener('click', function () { activar(k); });
        it.addEventListener('mouseenter', function () { activar(k); });
        it.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); activar(k); } });
      });
      activar(0);
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-mt-faq]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      sec.querySelectorAll('.mt-faq-item').forEach(function (item) {
        var btn = item.querySelector('.mt-faq-preg');
        btn.addEventListener('click', function () {
          var abierto = item.classList.toggle('mt-abierto');
          btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Producto: variantes + galería (página y tarjeta de compra) ---------- */
  function formatearDinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var entero = valor.split('.')[0];
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, entero)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, entero)
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (cont) {
      if (cont.dataset.mtInit) return;
      cont.dataset.mtInit = '1';
      var datosEl = cont.querySelector('script[data-mt-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(datosEl ? datosEl.textContent : '[]'); } catch (e) { variantes = []; }
      var formato = cont.dataset.mtFormato;
      var inputId = cont.querySelector('input[name="id"]');
      var precio = cont.querySelector('[data-mt-precio]');
      var tachado = cont.querySelector('[data-mt-tachado]');
      var boton = cont.querySelector('[data-mt-boton]');
      var agotado = cont.querySelector('[data-mt-agotado]');
      var principal = cont.querySelector('[data-mt-principal]');
      var minis = cont.querySelectorAll('[data-mt-mini]');

      function cambiarFoto(src, mini) {
        if (!principal || !src) return;
        principal.style.opacity = '0.4';
        var img = new Image();
        img.onload = function () { principal.src = src; principal.removeAttribute('srcset'); principal.style.opacity = '1'; };
        img.src = src;
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { cambiarFoto(m.dataset.mtMini, m); });
      });

      var selects = cont.querySelectorAll('[data-mt-opcion]');
      function actualizar() {
        if (!variantes.length) return;
        var elegidas = [];
        cont.querySelectorAll('[data-mt-opcion-grupo]').forEach(function (g) {
          var marcado = g.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (vr) {
          return vr.options.every(function (o, i) { return elegidas[i] === null || o === elegidas[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatearDinero(v.price, formato);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = formatearDinero(v.compare_at_price, formato); tachado.hidden = false; }
          else { tachado.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          var txt = boton.querySelector('[data-mt-boton-txt]');
          if (txt) txt.textContent = v.available ? boton.dataset.mtTxtComprar : boton.dataset.mtTxtAgotado;
        }
        if (agotado) agotado.hidden = v.available;
        if (v.featured_image && v.featured_image.src) {
          var mini = null;
          minis.forEach(function (m) { if (m.dataset.mtMediaId && String(m.dataset.mtMediaId) === String(v.featured_media && v.featured_media.id)) mini = m; });
          cambiarFoto(v.featured_image.src, mini);
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }


  /* ---------- Lluvia realista (canvas) ---------- */
  function initLluvia(root) {
    if (sinMovimiento) return;
    (root || document).querySelectorAll('[data-mt-lluvia]').forEach(function (capa) {
      if (capa.dataset.mtInit) return;
      capa.dataset.mtInit = '1';
      var canvas = capa.querySelector('canvas');
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext('2d');
      var densidad = (parseInt(capa.dataset.mtLluvia, 10) || 70) / 70;
      var W = 0, H = 0, dpr = 1, gotas = [], salpicones = [], visible = false, raf = null, ultimo = 0;
      var viento = 0.16;
      function nuevaGota(inicio) {
        var z = Math.pow(Math.random(), 1.6) * 0.85 + 0.15; // profundidad: 0.15 lejos - 1 cerca
        return {
          x: Math.random() * (W + H * viento) - H * viento * 0.2,
          y: inicio ? Math.random() * H : -Math.random() * H * 0.3 - 20,
          z: z,
          v: (700 + 1500 * z) * (0.9 + Math.random() * 0.2),
          len: 8 + 34 * z,
          w: 0.5 + 1.3 * z,
          a: 0.12 + 0.5 * z,
          suelo: H * (0.62 + Math.random() * 0.38)
        };
      }
      function medir() {
        var r = capa.getBoundingClientRect();
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = r.width; H = r.height;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round((W * H) / 1500 * densidad);
        n = Math.max(60, Math.min(n, 900));
        gotas = []; for (var i = 0; i < n; i++) gotas.push(nuevaGota(true));
      }
      function salpicar(x, y, z) {
        var k = 2 + Math.floor(Math.random() * 3);
        for (var i = 0; i < k; i++) {
          salpicones.push({ x: x, y: y, vx: (Math.random() - 0.5) * 120 * z, vy: -(60 + Math.random() * 120) * z, vida: 0, max: 0.28 + Math.random() * 0.2, r: 0.6 + z * 0.9, anillo: false });
        }
        salpicones.push({ x: x, y: y, vida: 0, max: 0.35, r: 2 + 6 * z, anillo: true, z: z });
      }
      function frame(t) {
        raf = null;
        if (!visible || !capa.classList.contains('mt-activa')) { ultimo = 0; return; }
        var dt = ultimo ? Math.min((t - ultimo) / 1000, 0.05) : 0.016; ultimo = t;
        // rafagas suaves de viento
        viento = 0.14 + Math.sin(t / 2300) * 0.05 + Math.sin(t / 900) * 0.015;
        ctx.clearRect(0, 0, W, H);
        ctx.lineCap = 'round';
        for (var i = 0; i < gotas.length; i++) {
          var g = gotas[i];
          var dy = g.v * dt, dx = -g.v * viento * dt;
          g.y += dy; g.x += dx;
          if (g.y - g.len > H) { gotas[i] = nuevaGota(false); continue; }
          var lx = g.len * viento, ly = g.len;
          var grad = ctx.createLinearGradient(g.x + lx, g.y - ly, g.x, g.y);
          grad.addColorStop(0, 'rgba(215,228,240,0)');
          grad.addColorStop(1, 'rgba(225,236,247,' + g.a.toFixed(3) + ')');
          ctx.strokeStyle = grad; ctx.lineWidth = g.w;
          ctx.beginPath(); ctx.moveTo(g.x + lx, g.y - ly); ctx.lineTo(g.x, g.y); ctx.stroke();
        }
        for (var j = salpicones.length - 1; j >= 0; j--) {
          var p = salpicones[j]; p.vida += dt;
          var k = p.vida / p.max;
          if (k >= 1) { salpicones.splice(j, 1); continue; }
          if (p.anillo) {
            ctx.strokeStyle = 'rgba(225,236,247,' + (0.35 * (1 - k) * p.z).toFixed(3) + ')';
            ctx.lineWidth = 0.8;
            ctx.beginPath(); ctx.ellipse(p.x, p.y, p.r * (0.4 + k * 1.6), p.r * (0.12 + k * 0.4), 0, 0, Math.PI * 2); ctx.stroke();
          } else {
            p.vy += 900 * dt; p.x += p.vx * dt; p.y += p.vy * dt;
            ctx.fillStyle = 'rgba(225,236,247,' + (0.55 * (1 - k)).toFixed(3) + ')';
            ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
          }
        }
        raf = requestAnimationFrame(frame);
      }
      function arrancar() { if (!raf && visible && capa.classList.contains('mt-activa')) { ultimo = 0; raf = requestAnimationFrame(frame); } }
      medir();
      if ('ResizeObserver' in window) new ResizeObserver(function () { medir(); }).observe(capa);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; arrancar(); }, { threshold: 0.05 }).observe(capa);
      } else { visible = true; }
      new MutationObserver(arrancar).observe(capa, { attributes: true, attributeFilter: ['class'] });
      arrancar();
    });
  }

  function initTodo(ev) {
    var root = ev && ev.target && ev.target.nodeType === 1 ? ev.target : document;
    initReveals(root);
    initFoco(root);
    initMagnetico(root);
    initEscenarios(root);
    initHotspots(root);
    initFaq(root);
    initProducto(root);
    initLluvia(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
